<template>
    <transition name="modal">
        <div class="modal-mask" v-show="show" v-shortkey="['ctrl', 'enter']" @shortkey="adiciona()">
            <div class="modal-container">
                <div class="modal-header">
                    <h3>Deseja incluir este procedimento na solicitação?</h3>
                </div>
                <div class="modal-body">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <b>
                                        <h3 class="text-center">{{ $props.contratoProcedimento.procedimento.codigo }}</h3>
                                    </b>
                                    <h4 class="text-center">{{ $props.contratoProcedimento.procedimento.nome }}</h4>
                                </div>
                            </div>
                            <br />
                            <form action>
                                <div class="row">
                                    <div class="form-group col-md-6">
                                        <label for>Quantidade:</label>
                                        <input :disabled="$props.contratoProcedimento.procedimento.quantidade_maxima == 1 || this.$props.contratoProcedimento.procedimento.tipo_atendimento == 1" v-model="quantidade" type="number" class="form-control" />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label for>Tipo de Atendimento:</label>
                                        <select v-model="tipoConsulta" class="form-control">
                                            <option v-if="this.$store.state.user.nivel != 'prestador'" :value="TIPO_CONSULTA.PRIMEIRA">Primeira</option>
                                            <option v-if="this.$store.state.user.nivel != 'prestador'" :value="TIPO_CONSULTA.RETORNO">Retorno</option>
                                            <option v-if="this.$store.state.user.nivel == 'prestador'" :value="TIPO_CONSULTA.LOCAL">Local</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="row" v-show="showMsgQtdMax">
                                    <div class="col-sm-12">
                                        <p style="color: red">A quantidade informada é maior que a quantidade máxima permitida para este procedimento.</p>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <div class="text-right" style="float:right">
                        <button class="btn btn-default" @click="$emit('close')"><i class="fa fa-close"></i> Fechar</button>
                        <button ref="btnAdicionar" @click="adiciona()" type="button" class="btn btn-primary"><span class="fa fa-plus"></span> Adicionar ( ctrl + enter )</button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import { TIPO_CONSULTA } from "@/constants";
export default {
    props: ["show", "contratoProcedimento"],
    filters: {},
    data: () => ({
        showMsgQtdMax: false,
        quantidade: 1,
        tipoConsulta: 0
    }),
    mounted() {
        if (this.$store.state.user.nivel == "prestador") {
            this.tipoConsulta = 2;
        }
    },
    methods: {
        adiciona() {
            if (this.$props.contratoProcedimento.procedimento.quantidade_maxima > 1) {
                if (this.quantidade > this.$props.contratoProcedimento.procedimento.quantidade_maxima) {
                    this.showMsgQtdMax = true;
                    setInterval(() => {
                        this.showMsgQtdMax = false;
                    }, 4000);
                    return false;
                }
            }

            this.$props.contratoProcedimento.procedimento.quantidade = this.quantidade;
            this.$props.contratoProcedimento.procedimento.tipo_consulta = this.tipoConsulta;
            this.$emit("addProcedimentoSelecionado", this.$props.contratoProcedimento);
            this.quantidade = 1;
            this.tipoConsulta = 0;

            if (this.$store.state.user.nivel == "prestador") {
              this.tipoConsulta = 2;
            }
        }
    },
    computed: {
        TIPO_CONSULTA: function() {
            return TIPO_CONSULTA;
        }
    },
    components: {}
};
</script>

<style scoped>
* {
    box-sizing: border-box;
}

.modal-mask {
    position: fixed;
    z-index: 1001;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
}

.modal-container {
    width: 30%;
    height: auto;
    margin: 60px auto 0;
    padding: 10px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
    margin-top: 0;
    color: #333;
}

.modal-body {
    height: 250px;
    overflow-y: auto;
}

.text-right {
    text-align: right;
}

.form-label {
    display: block;
    margin-bottom: 1em;
}

.form-label > .form-control {
    margin-top: 0.5em;
}

.form-control {
    display: block;
    width: 100%;
    padding: 0.5em 1em;
    line-height: 1.5;
    border: 1px solid #ddd;
}

/*
										 * The following styles are auto-applied to elements with
										 * transition="modal" when their visibility is toggled
										 * by Vue.js.
										 *
										 * You can easily play with the modal transition by editing
										 * these styles.
										 */

.modal-enter {
    opacity: 0;
}

.modal-leave-active {
    opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
}

.modal {
    display: block !important;
    /* I added this to see the modal, you don't need this */
}

/* Important part */

.modal-dialog {
    overflow-y: initial !important;
}

.modal-body {
    height: 300px;
    overflow-y: auto;
}
</style>



// WEBPACK FOOTER //
// modalQuantidadeProcedimentos.vue?72de83a2